import React from 'react';
import { CodeSnippet } from '@graphql/gql/graphql';
import useCodeSnippets from '@hooks/useCodeSnippets';
import CodeSnippets from './CodeSnippets';

type CodeSnippetsWithCategory = {
  codeSnippets: CodeSnippet[];
  showCookieBanner: boolean;
  showNonEssentialCookieBanner: boolean;
};

function CodeSnippetsWithCategory({
  codeSnippets,
  showCookieBanner,
  showNonEssentialCookieBanner
}: CodeSnippetsWithCategory): JSX.Element {
  const snippets = useCodeSnippets({ codeSnippets, showCookieBanner, showNonEssentialCookieBanner });

  return <CodeSnippets snippets={snippets} />;
}

export default CodeSnippetsWithCategory;
